import useTranslation from 'next-translate/useTranslation'
import { memo, useState } from 'react'

import IconContainer from './icons/IconContainer'

type RewardsSummaryCategory = {
  iconName: string
  title: string
  items: {
    title: string
    description: string
    label?: string
  }[]
}

const RewardsSummaryCategory = ({
  iconName,
  title,
  items
}: RewardsSummaryCategory) => (
  <>
    <h2 className="py-0.5 font-semibold">
      <IconContainer
        className="mr-4 inline-block"
        height={40}
        name={iconName}
        width={40}
      />
      {title}
    </h2>

    <ul>
      {items.map(({ title: itemTitle, description, label }) => (
        <li
          className="relative mb-4 px-2 pl-11 text-sm leading-[22px]"
          key={itemTitle}
        >
          <IconContainer className="absolute left-2 top-0" name="checkcircle" />
          {label && (
            <span className="text-teal-primary absolute -top-1 right-1 px-2 py-1 text-xs leading-[20px]">
              {label}
            </span>
          )}
          <h3 className="mb-1 font-semibold">{itemTitle}</h3>
          <p>{description}</p>
        </li>
      ))}
    </ul>
  </>
)

const RewardsSummary = function () {
  const { t } = useTranslation()
  const [opened, setOpened] = useState(true)

  return (
    <div className="bg-block relative h-fit w-full space-y-4 rounded-md p-6 text-white md:w-5/12">
      <span className="text-lg font-medium">{t('rewards-summary.title')}</span>
      <div
        className={`absolute right-6 top-2 h-6 w-6 rounded-full bg-white/10
        ${
          opened ? '-rotate-90' : 'rotate-0'
        } cursor-pointer transition-transform
      `}
        onClick={() => setOpened(o => !o)}
      >
        <IconContainer fill="white" height={14} name="chevronleft" width={14} />
      </div>
      {opened && (
        <div className="bg-blue-secondary space-y-4 rounded-lg p-2">
          <RewardsSummaryCategory
            iconName="vote"
            items={[
              {
                description: t('rewards-summary.voting-power.description'),
                title: t('rewards-summary.voting-power.title')
              }
            ]}
            title={t('rewards-summary.governance')}
          />
          <RewardsSummaryCategory
            iconName="metalt"
            items={[
              ...(process.env.NEXT_PUBLIC_FLAGS_DISPLAY_REWARDS === 'true'
                ? [
                    {
                      description: t('rewards-summary.rewards.description'),
                      title: t('rewards-summary.rewards.title')
                    }
                  ]
                : []),
              {
                description: t(
                  'rewards-summary.trading-fee-discount.description'
                ),
                title: t('rewards-summary.trading-fee-discount.title')
              }
            ]}
            title={t('rewards-summary.protocol')}
          />
        </div>
      )}
    </div>
  )
}

export default memo(RewardsSummary)
